import { FileUpload } from "primereact/fileupload";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";
import { InputNumber } from "primereact/inputnumber";
import { useRef } from "react";
import UserEditService from "../../../../service/UserEditService";
import GetInfoService from "../../../../service/GetInfoService";
import localeText from "../../../../locale";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";

const countryIsItalia = (country) => {
  if (
    country?.toLowerCase() === "italy" ||
    country?.toLowerCase() === "it" ||
    country?.toLowerCase() === "italia"
  )
    return true;
  return false;
};

const EditProfileInfo = (props) => {
  const [pfp, setPfp] = useState(null);
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [district, setDistrict] = useState("");
  const [firstname, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [internationalCode, setInternationalCode] = useState("");
  const [localCode, setLocalCode] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [canRetriveOnSaturdays, setCanRetriveOnSaturdays] = useState(false);
  const [amountDaysToPickUp, setAmountDaysToPickUp] = useState();
  const [usernameCheckIcon, setUsernameCheckIcon] = useState("");
  const { showSuccessToast } = useToastContext();

  const toast = useRef(null);
  const usernameRef = useRef(null);
  const fileUploadRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const userEditService = new UserEditService();
  const getInfoService = new GetInfoService();

  const uploadOptions = {
    // label: The label of button.
    // icon: The icon of button.
    className: "hidden",
    // style:
  };

  async function changeProfilePicture(pfp) {
    setLoading(true);

    // No file uploaded validation
    if (pfp === null) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("pleaseChoosePfp"),
        life: 6000,
      });
      setLoading(false);
      return false;
    }

    // File size validation
    if (pfp.size / 1024 / 1024 > 5) {
      fileUploadRef.current.clear();
      setPfp(null);
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("fileSizeTooBig"),
        life: 6000,
      });
      setLoading(false);
      return false;
    }

    try {
      const res = await userEditService.postChangeProfilePicture(
        localStorage.getItem("__extraconomy_token"),
        pfp,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200002) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
        return false;
      } else window.location.reload();
    } catch (e) {
      if (e.status === 401) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else if (e.status === 500) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedSystemBehaviour"),
          life: 6000,
        });
        setLoading(false);
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("unexpectedErrorUploadImg"),
          life: 6000,
        });
        setLoading(false);
      }
    }
  }

  async function findUsername(username) {
    if (username.length === 0) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("usernameCantBeEmpty"),
        life: 6000,
      });
      usernameRef.current.style.border = "1px solid red";
      setUsernameCheckIcon("pi pi-times");
      return false;
    }

    if (username === props.user.username) {
      usernameRef.current.style.border = "1px solid #ced4da";
      setUsernameCheckIcon("");
      return;
    }

    try {
      if (username.length > 0) usernameRef.current.style.border = "1px solid #ced4da";
      setUsernameCheckIcon("pi pi-spin pi-spinner");
      const res = await getInfoService.getFindUsername(username);

      if (res.messageCode === 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("usernameNotAvailable"),
          life: 6000,
        });
        setUsernameCheckIcon("pi pi-times");

        usernameRef.current.style.border = "1px solid red";

        return false;
      } else {
        setUsername(username);
        setUsernameCheckIcon("pi pi-check");

        usernameRef.current.style.border = "1px solid #46a748";

        return true;
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    let cancel = false;

    async function constructUserInfo() {
      if (props.user !== null) {
        // Turning null into empty string for input text
        setAddress(props.user.address === null ? "" : props.user.address);
        setCity(props.user.city === null ? "" : props.user.city);

        let language = "en";
        switch (props.user.language) {
          case "PORTUGUESE":
            language = "pt-br";
            break;
          case "ITALIAN":
            language = "it";
            break;
          default:
            break;
        }
        const regionNames = new Intl.DisplayNames([language], { type: "region" });

        if (props.user.country)
          setCountry(
            props.user.country.length === 2
              ? regionNames.of(props.user.country)
              : props.user.country
          );
        else {
          const countryISO = await getInfoService.getUserCountry();
          if (cancel) return;
          setCountry(regionNames.of(countryISO));
        }

        setDistrict(props.user.district === null ? "" : props.user.district);
        setFirstName(props.user.firstname === null ? "" : props.user.firstname);
        setSurname(props.user.surname === null ? "" : props.user.surname);
        setInternationalCode(
          props.user.internationalCode === null ? "" : props.user.internationalCode
        );
        setLocalCode(props.user.localCode === null ? "" : props.user.localCode);
        setNumber(props.user.number === null ? "" : props.user.number);
        setState(props.user.state === null ? "" : props.user.state);
        setPostalCode(props.user.postalCode === null ? "" : props.user.postalCode);
        setUsername(props.user.username === null ? "" : props.user.username);
        setPhoneNumber(props.user.phoneNumber === null ? "" : props.user.phoneNumber);
        setCanRetriveOnSaturdays(props.user?.canRetriveOnSaturdays);
        setAmountDaysToPickUp(props.user?.amountDaysToPickUp);
        setCanRetriveOnSaturdays(props.user?.pickupOnSaturday);
      }
    }

    constructUserInfo();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.user]);

  async function confirmChanges(args) {
    setLoading(true);

    // Empty strings turn into null
    Object.keys(args).forEach((k) => (args[k] = args[k] === "" ? null : args[k]));

    if (args.username === null) {
      toast.current.show({
        severity: "error",
        summary: localeText("error"),
        detail: localeText("usernameCantBeEmpty"),
        life: 6000,
      });
      setLoading(false);
      return false;
    }
    try {
      const res = await userEditService.postChangeProfileInfo(
        localStorage.getItem("__extraconomy_token"),
        args
      );
      // props?.setUserInfo  para fazer setar o novo user info
      if (res.messageCode !== 200000) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        setLoading(false);
        return false;
      } else {
        showSuccessToast({ detail: "sucessfullyEditedProfile" });
        props?.setUserInfo(res.result);
        setLoading(false);
        return true;
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  }

  async function checkZipCode(zip) {
    if (zip.length > 0) {
      try {
        const zip_ = zip.replace(/\D+/g, "");

        setLoading(true);

        const userCountry = await getInfoService.getUserCountry();
        const res = await getInfoService.getZipCodeInfo(zip_, userCountry);

        if (Array.isArray(res.results) && res.results.length === 0) {
          setDistrict("");
          setState("");
          setCity("");
          setLoading(false);
        } else if (res.results[`${zip_}`][0]) {
          setDistrict(res.results[`${zip_}`][0].city);
          setCity(res.results[`${zip_}`][0].province);
          setState(res.results[`${zip_}`][0].state_en);
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
  }

  return (
    <>
      <Toast ref={toast} />
      {props.user !== null && (
        <div className="card">
          <div className="grid mt-4">
            <div className="col-12 lg:col-2 md:col-2">
              <div
                className="h-8rem w-8rem m-auto my-4"
                style={{
                  background: `url(${props.user.urlAvatar})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
            <div className="col-12 lg:col-10 md:col-10">
              <FileUpload
                uploadOptions={uploadOptions}
                chooseLabel={localeText("choose")}
                cancelLabel={localeText("cancel")}
                name="demo"
                onSelect={(e) => setPfp(e.files[0])}
                onClear={() => setPfp(null)}
                onRemove={() => setPfp(null)}
                onError={() => setPfp(null)}
                onValidationFail={() => setPfp(null)}
                accept="image/*"
                ref={fileUploadRef}
                emptyTemplate={
                  <div className="text-center">
                    <i className="pi pi-upload text-400" style={{ fontSize: "3em" }}></i>
                    <h3 className="text-400">{localeText("dragImgFile")}</h3>
                  </div>
                }
              />
            </div>
          </div>

          <div className="field text-center pt-4">
            <Button
              label={localeText("changeProfilePic")}
              onClick={() => changeProfilePicture(pfp)}
              loading={loading}
            />
          </div>

          <div className="grid mt-6">
            <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
              <label htmlFor="firstname">{localeText("firstName")}</label>
              <InputText
                className="w-full my-2"
                name="firstname"
                value={firstname}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
              <label htmlFor="surname">{localeText("surname")}</label>
              <InputText
                className="w-full my-2"
                name="surname"
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
              />
            </div>
            <div className="col-12">
              <label htmlFor="username">{localeText("username")}</label>
              <span className="p-input-icon-right w-full">
                <i className={usernameCheckIcon} />
                <InputText
                  className="w-full my-2"
                  name="username"
                  ref={usernameRef}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onBlur={(e) => findUsername(e.target.value)}
                />
              </span>
            </div>

            {(props.plan === "Manager" || props.plan === "Partner") && (
              <div className="col-12 flex align-items-center w-full my-2">
                <i className="pi pi-exclamation-circle mr-2 text-xl"></i>
                <p className="font-bold">{localeText("thisIsPickupAddress")}</p>
              </div>
            )}
            <div id="step-2" className="flex flex-wrap">
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="postalCode">{localeText("zipCode")}</label>
                <span className="p-input-icon-right w-full">
                  {loading && <i className="pi pi-spin pi-spinner" />}
                  <InputText
                    className="w-full my-2"
                    name="postalCode"
                    value={postalCode}
                    onChange={(e) => setPostalCode(e.target.value)}
                    onBlur={(e) => checkZipCode(e.target.value)}
                    disabled={loading}
                  />
                </span>
              </div>
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="country">{localeText("country")}</label>
                <InputText className="w-full my-2" name="country" value={country} disabled={true} />
              </div>
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="state">{localeText("state")}</label>
                <InputText
                  className="w-full my-2"
                  name="state"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="address">{localeText("city")}</label>
                <InputText
                  className="w-full my-2"
                  name="city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="district">{localeText("district")}</label>
                <InputText
                  className="w-full my-2"
                  name="district"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="address">{localeText("publicPlace")}</label>
                <InputText
                  className="w-full my-2"
                  name="address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>
            <div className="flex flex-wrap w-full" id="step-3">
              <div className="lg:col-4 md:col-4 sm:col-12 w-full lg:w-4 md:w-4">
                <label htmlFor="number">{localeText("number")}</label>
                <InputText
                  className="w-full my-2"
                  name="number"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  disabled={loading}
                />
              </div>

              <div className="lg:col-4 md:col-4 sm:col-12 w-full lg:w-4 md:w-4">
                <label htmlFor="internationalCode">{localeText("countryPhoneCode")}</label>
                <InputText
                  className="w-full my-2"
                  name="internationalCode"
                  value={internationalCode}
                  onChange={(e) => setInternationalCode(e.target.value)}
                />
              </div>
              {!countryIsItalia(country) && (
                <div className="lg:col-4 md:col-4 sm:col-12 w-full lg:w-4 md:w-4">
                  <label htmlFor="localCode">{localeText("regionalPhoneCode")}</label>
                  <InputText
                    className="w-full my-2"
                    name="localCode"
                    value={localCode}
                    onChange={(e) => setLocalCode(e.target.value)}
                  />
                </div>
              )}
              <div className="lg:col-4 md:col-4 sm:col-12 w-full lg:w-4 md:w-4">
                <label htmlFor="phoneNumber">{localeText("phoneNumber")}</label>
                <InputText
                  className="w-full my-2"
                  name="phoneNumber"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
            </div>

            <div className="flex flex-wrap w-full" id="step-4">
              <h3 className="w-full ml-2">{localeText("freight")}</h3>

              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="address">{localeText("quantityOfDaysToRetrive")}</label>

                <div className="flex align-items-center mt-3">
                  <InputNumber
                    className="w-full"
                    value={amountDaysToPickUp}
                    onValueChange={(e) => setAmountDaysToPickUp(e.value)}
                    disabled={loading}
                    placeholder="0"
                  />
                </div>
              </div>

              <div className="lg:col-6 md:col-6 sm:col-12 w-full lg:w-6 md:w-6">
                <label htmlFor="address" className="mb-4">
                  {localeText("canRetriveOnSaturdays")}
                </label>
                <div className="flex align-items-center mt-3">
                  <Checkbox
                    inputId="canRetriveOnSaturdays"
                    onChange={(e) => setCanRetriveOnSaturdays(e.checked)}
                    checked={canRetriveOnSaturdays}
                    disabled={loading}
                  />
                  <label htmlFor="canRetriveOnSaturdays" className="ml-2">
                    {localeText("yes")}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center my-4" id="step-5-mobile">
            <Button
              id="step-5"
              label={localeText("confirmProfileChanges")}
              onClick={() =>
                confirmChanges({
                  firstname: firstname,
                  surname: surname,
                  username: username,
                  postalCode: postalCode,
                  country: country,
                  state: state,
                  city: city,
                  address: address,
                  district: district,
                  number: number,
                  internationalCode: internationalCode,
                  localCode: localCode,
                  phoneNumber: phoneNumber,
                  amountDaysToPickUp: amountDaysToPickUp,
                  pickupOnSaturday: canRetriveOnSaturdays,
                })
              }
              loading={loading}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EditProfileInfo;
